import { Stack } from '@mui/material';
import useProductDetailsStore from '../../../stores/ProductDetails/productDetails.store';
import { useRachelFocusedLabel } from '../../rachel/hooks/useRachelFocusedLabel';
import ProductDetailsContentHeader from './ProductDetailsContentHeader';
import ProductDetailsContentPrices from './ProductDetailsContentPrices';
import ProductDetailsFilter from './filters/ProductDetailsFilter';
import { ProductDetailsHeaderProps } from './types/productDetails.types';

const ProductDetailsHeader = ({
  name,
  code,
  tags,
  prices,
  allColorIds,
  referenceCode,
  productColorName,
  productColorCode,
  titleRef,
}: ProductDetailsHeaderProps) => {
  const isFinishedOrder = useProductDetailsStore(
    (state) => state.productGridParams?.isFinishedOrder,
  );
  const showProductColorFilter = !!productColorName && !!productColorCode;
  useRachelFocusedLabel([name, productColorName].filter(Boolean).join(' - '));

  return (
    <Stack spacing={2}>
      <ProductDetailsContentHeader
        name={name}
        code={code}
        referenceCode={referenceCode}
        tags={tags}
        titleRef={titleRef}
      />

      {showProductColorFilter && (
        <ProductDetailsFilter
          allColorIds={allColorIds}
          productColorCode={productColorCode}
          productColorName={productColorName}
        />
      )}

      {!isFinishedOrder && <ProductDetailsContentPrices prices={prices} />}
    </Stack>
  );
};

export default ProductDetailsHeader;
